import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="linkman";
export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function insertBatch(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}/insertBatch`,
     method: 'post',
     data:parameter
   })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}



export function deleteObj(id){
  console.log("ids",id)
  let ids = {idList:[id]}
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function saveShare(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveShare`,
    method: 'post',
    data:parameter
  })
}
export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export function listByTypeAndCompanyId(type,companyId) {
  return axios({
    url: `/ws/${moduleName}/listByTypeAndCompanyId/${type}/${companyId}`,
    method: 'get',
  })
}

export function queryByName(parameter,mansionId) {
  return axios({
    url: `/ws/${moduleName}/queryByName/${parameter}`,
    method: 'get',
    params:{mansionId:mansionId?mansionId:''},
  })
}

export function queryAllByName(parameter,mansionId) {
  return axios({
    url: `/ws/${moduleName}/queryAllByName/${parameter}`,
    method: 'get',
    params:{mansionId:mansionId?mansionId:''},
  })
}

export default {
  insert,
  insertBatch,
  update,
  selectAll,
  selectOne,
  listByTypeAndCompanyId,
  queryByName,
  queryAllByName,
  saveShare,
  deleteObj
}